import React from "react";
import { keyframes } from "styled-components";

/**
 * Fadein animation.
 */
export const fadeInAnimation = keyframes`
  0% {opacity: 0;}
  100% {opacity: 1;}
`;

export const TypingAnimation = () => {
  return (
    <svg
      width="40px"
      height="35px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle cx="26" cy="58" r="6" fill="#777777">
        <animate
          attributeName="cy"
          calcMode="spline"
          keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
          repeatCount="indefinite"
          values="58;42;58;58"
          keyTimes="0;0.35;0.7;1"
          dur="0.7s"
          begin="-0.48999999999999994s"
        />
      </circle>
      <circle cx="50" cy="44.954" r="6" fill="#777777">
        <animate
          attributeName="cy"
          calcMode="spline"
          keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
          repeatCount="indefinite"
          values="58;42;58;58"
          keyTimes="0;0.35;0.7;1"
          dur="0.7s"
          begin="-0.3266666666666666s"
        />
      </circle>
      <circle cx="74" cy="42.1758" r="6" fill="#777777">
        <animate
          attributeName="cy"
          calcMode="spline"
          keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
          repeatCount="indefinite"
          values="58;42;58;58"
          keyTimes="0;0.35;0.7;1"
          dur="0.7s"
          begin="-0.1633333333333333s"
        />
      </circle>
    </svg>
  );
};
